// extracted by mini-css-extract-plugin
export default {"InfoCard":"infoCard_InfoCard__lT6xl"};